import React from 'react';
const BONUSES = [{
  id: 1,
  title: 'BONO #1 – Guía de hábitos sanos',
  desc: 'Rutinas simples para reducir pantallas y ordenar el día.',
  img: 'https://cdn.magicpatterns.com/uploads/bpPzgbywkuydxT26N5Ftyx/ChatGPT_Image_31_ene_2026,_01_43_40_a.m..png'
}, {
  id: 2,
  title: 'BONO #2 – Cómo mejorar la concentración',
  desc: 'Técnicas, juegos y un plan práctico de 7 días.',
  img: 'https://cdn.magicpatterns.com/uploads/irycKi2kxsdtDC2iYZi5ec/ChatGPT_Image_31_ene_2026,_01_44_35_a.m..png'
}, {
  id: 3,
  title: 'BONO #3 – Actividades familiares',
  desc: 'Ideas reales para reconectar y crear recuerdos.',
  img: 'https://cdn.magicpatterns.com/uploads/mPb5VQAxNGDie68XWbqBcR/ChatGPT_Image_31_ene_2026,_01_45_17_a.m..png'
}];
interface BonusesProps {
  onScrollToPrice: () => void;
}
export function Bonuses({
  onScrollToPrice
}: BonusesProps) {
  return <div className="space-y-12" data-id="element-39">
      {BONUSES.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-dashed border-red-200 transform hover:scale-[1.01] transition-transform duration-300 cursor-pointer" onClick={onScrollToPrice} data-id="element-40">
          <div className="flex flex-col md:flex-row items-center" data-id="element-41">
            <div className="w-full md:w-1/2 p-6 flex justify-center bg-gray-50" data-id="element-42">
              <img src={bonus.img} alt={bonus.title} className="w-full max-w-[350px] object-cover shadow-lg rounded-lg" data-id="element-43" />
            </div>
            <div className="w-full md:w-1/2 p-8 text-center md:text-left" data-id="element-44">
              <span className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-45">
                Gratis Hoy
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-46">
                {bonus.title}
              </h3>
              <p className="text-xl text-gray-600 mb-6" data-id="element-47">{bonus.desc}</p>
              <div className="text-green-600 font-bold text-lg" data-id="element-48">
                Valorado en:{' '}
                <span className="line-through text-gray-400" data-id="element-49">$15.000</span>{' '}
                <span className="text-red-600" data-id="element-50">¡GRATIS!</span>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}